export default function(context) {
  //context.$store.dispatch("DelegationOrder/editDelegationOrder", context.contextItemId);
  context.$router.push("/delegation-order/edit/" + context.contextItemId);
}
